import Api from "./api"

export default {
		user() {
			return Api().get("/auth/user")
		},
		
    register(data) {
        return Api().post("/auth/signup", data)
    },

    login(data) {
        return Api().post("/auth/login", data)
    },

    logout() {
        return Api().get("/auth/logout")
    },

    update(data) {
        return Api().post("/auth/update", data)
    },

		forgot(data) {
			return Api().post("/password/forgot", data)
		},

		reset(data) {
			return Api().post("/password/reset", data)
		},

		verify(data) {
			return Api().post("/password/verify", data)
		}
}